<a *ngIf="href" class="app-link" [href]="href" [title]="title">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</a>
<a
    *ngIf="!href && appRouterLink"
    class="app-link"
    [routerLink]="appRouterLink"
    [queryParams]="queryParams"
    [queryParamsHandling]="queryParamsHandling"
    routerLinkActive="routerLinkActive"
    [title]="title"
>
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</a>
<ng-template #contentTpl><ng-content></ng-content></ng-template>
